import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { useState } from "react";

const DetailBar = props => {
  const { shipment } = props;
  const [open, setOpen] = useState(false);

  const shipmentDetails = [
    { label: "Delivered on", value: shipment?.delivered },
    {
      label: "Consigner",
      value: `${shipment?.consignor?.name ?? ""} - ${shipment?.consignor?.company ?? ""}`,
    },
    {
      label: "Consignee",
      value: `${shipment?.consignee?.name ?? ""} - ${shipment?.consignee?.company ?? ""}`,
    },
    { label: "EORI", value: shipment?.eori },
    { label: "CDS", value: shipment?.cds },
  ];

  const blocksClassNames = {
    label: "w-[100px] min-w-[100px] text-xs capitalise font-bold",
    block: "flex flex-row pb-3 flex-1",
    detail: "pl-4 text-sm break-all w-full",
  };

  return (
    <>
      <div className="hidden min-h-full border border-b-0 border-l-0 border-t-0 border-gray-200 lg:block">
        {open ? (
          <div className="w-full p-4 sm:p-6 lg:min-w-[350px] lg:max-w-[400px]">
            <div className="flex w-full flex-col gap-3 sm:flex-row">
              <div className="mb-4">
                <ChevronLeftIcon
                  className="h-7 w-7 cursor-pointer"
                  onClick={() => setOpen(false)}
                />
              </div>
            </div>
            {shipmentDetails?.map((item, index) => {
              return (
                <div className={blocksClassNames.block} key={index}>
                  <div className={blocksClassNames.label}>{item.label}</div>
                  <div className={blocksClassNames.detail}>{item.value}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex min-h-full flex-col px-[14px] py-[20px]">
            <ChevronRightIcon
              className="h-5 w-5 cursor-pointer"
              onClick={() => setOpen(true)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DetailBar;
